import './ScheduleCard.css'

import React from 'react'
import Paper from 'material-ui/Paper'

import InlineIconWrapper from '../components/InlineIconWrapper'
import TimeIcon from '../assets/svg/TimeIcon'
import LocIcon from 'material-ui/svg-icons/communication/location-on'

const ScheduleCard = ({
  id,
  location,
  title,
  subtitle,
  image,
  imageAlt,
  color,
  time,
  onClick,
}) => {
  return (
    <Paper
      key={id}
      style={{ borderBottom: '3px solid ' + color }}
      className="ScheduleCard-container"
      onClick={onClick}
    >
      <div className="ScheduleCard-headerContainer">
        <h3>{subtitle}</h3>
        <h2>{title}</h2>
      </div>
      <div className="ScheduleCard-mediaContainer">
        {image && <img alt={imageAlt} style={{ width: '100%' }} src={image} />}
      </div>
      <div className="ScheduleCard-footerContainer" style={{ color }}>
        <div className="ScheduleCard-footerRight">
          <InlineIconWrapper
            iconComponent={TimeIcon}
            style={{ width: 8, height: 8, marginRight: 5 }}
          >
            {time}
          </InlineIconWrapper>
        </div>
        <div className="ScheduleCard-footerLeft">
          <InlineIconWrapper
            iconComponent={LocIcon}
            style={{ width: 11, height: 11, marginRight: 5 }}
          >
            {location}
          </InlineIconWrapper>
        </div>
      </div>
    </Paper>
  )
}

export default ScheduleCard



// WEBPACK FOOTER //
// ./src/components/ScheduleCard.js